import React from 'react'
import {Link} from "react-router-dom";
import {HomeBi, CollectionBi, Folder2OpenBi, ChatDotsBi} from "../../assets/svg/icon";
import {Badge} from 'antd';
import {CalculatorOutlined} from '@ant-design/icons';
import CustomIcon from "../util-components/CustomIcon";
import {connect} from "react-redux";

function Footer(props) {
  const {routeInfo, countUnreadMessages, allowedHelpDesk} = props;
  const getClassName = (key) => {
    return routeInfo?.key === key ? 'menu-item-selected' : '';
  }


	return (
		<footer className="footer">
			{/*<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold">{`${APP_NAME}`}</span> All rights reserved.</span>*/}

      <Link to={'/app/shipping/shipping-list'} className={getClassName('shippingList')} >
        <CustomIcon svg={HomeBi}/><span style={{marginTop: -5}}>Shipping</span>
      </Link>
      <Link to={'/app/payments/payments-list'} className={getClassName('payments-paymentsList')} >
        <CustomIcon svg={CollectionBi}/><span>Payments</span>
      </Link>
      <Link to={'/app/carfax'} className={getClassName('carfax')} >
        <CustomIcon svg={Folder2OpenBi}/><span>Carfax</span>
      </Link>
      {allowedHelpDesk === null ? null : allowedHelpDesk ? (
        <Link to={'/app/help-desk/tickets'} className={getClassName('helpDesk')} >
          <Badge count={countUnreadMessages}>
            <CustomIcon svg={ChatDotsBi}/><span>HelpDesk</span>
          </Badge>
        </Link>
      ) : (
        <Link to={'/app/tools/calculator'} className={getClassName('calculator-v2')} >
          <CalculatorOutlined style={{fontSize: 20}}/><span>Calculator</span>
        </Link>
      )}
		</footer>
	)
}

const mapStateToProps = ({ helpDesk }) => {
  const { countUnreadMessages, allowedHelpDesk } =  helpDesk;
  return { countUnreadMessages, allowedHelpDesk }
};

export default connect(mapStateToProps)(Footer);